// extracted by mini-css-extract-plugin
export default {"inputNormal":"index-module--input-normal--a12b9","inputWithError":"index-module--input-with-error--09c74"};